import { useState } from 'react';
import { FiStar, FiUser, FiThumbsUp } from 'react-icons/fi';

const formatDate = (d) =>
  new Date(d).toLocaleDateString('en-IN', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });

const ReviewItem = ({ review, onHelpful, isHelpful, isHelpfulPending }) => (
  <li className="border-b border-gray-100 pb-4">
    <header className="flex items-center gap-2 mb-1">
      <span className="w-7 h-7 bg-orange-100 rounded-full flex items-center justify-center">
        <FiUser className="text-orange-600 text-xs" />
      </span>
      <span className="text-sm font-medium text-black">{review.user}</span>
    </header>
    <div className="flex items-center gap-2 mb-1">
      <span className="flex items-center gap-0.5">
        {[1, 2, 3, 4, 5].map((i) => (
          <FiStar
            key={i}
            className={`text-xs ${
              i <= review.rating ? 'text-orange-400 fill-orange-400' : 'text-black'
            }`}
          />
        ))}
      </span>
      <span className="text-xs text-black">{formatDate(review.date)}</span>
    </div>
    <p className="text-sm text-black leading-relaxed mb-2">{review.text}</p>
    <button
      onClick={() => onHelpful(review.id)}
      type="button"
      disabled={isHelpful || isHelpfulPending}
      aria-pressed={isHelpful}
      className={`text-xs border rounded px-3 py-1 inline-flex items-center gap-1 ${
        isHelpful
          ? 'border-orange-300 bg-orange-50 text-orange-700 cursor-default'
          : 'border-gray-300 text-black hover:bg-gray-50 disabled:opacity-60'
      }`}
    >
      <FiThumbsUp className={isHelpful ? 'fill-current' : ''} />
      {isHelpfulPending ? 'Saving...' : `Helpful (${review.helpful})`}
    </button>
  </li>
);

const ReviewList = ({
  reviews = [],
  onHelpful,
  helpfulReviewIds = new Set(),
  helpfulPendingIds = new Set(),
  initialCount = 2,
}) => {
  const [showAll, setShowAll] = useState(false);
  if (!reviews || reviews.length === 0) {
    return (
      <p className="text-sm text-black">
        No reviews yet. Be the first to review this product!
      </p>
    );
  }
  const visible = showAll ? reviews : reviews.slice(0, initialCount);
  return (
    <>
      <ul className="space-y-5 list-none">
        {visible.map((r) => (
          <ReviewItem
            key={r.id}
            review={r}
            onHelpful={onHelpful}
            isHelpful={helpfulReviewIds.has(r.id)}
            isHelpfulPending={helpfulPendingIds.has(r.id)}
          />
        ))}
      </ul>
      {reviews.length > initialCount && (
        <button
          type="button"
          onClick={() => setShowAll((v) => !v)}
          className="mt-4 text-sm text-blue-700 hover:underline font-medium"
        >
          {showAll ? 'Show less' : `See more reviews (${reviews.length - initialCount})`}
        </button>
      )}
    </>
  );
};

export default ReviewList;
